module.exports = __webpack_public_path__ + "img/law2m.3448bf5c.jpg";